import domReady from "@wordpress/dom-ready";

domReady(() => {
	import("@splidejs/splide").then(({ Splide }) => {
		const el = document.querySelector(".splide");
		if (el) {
			new Splide(".splide", {
				perPage: 1,
				pauseOnHover: false,
				interval: 2000,
				type: "loop",
			}).mount();
		}
	});

	const { $$, each, toArray } = window.magazineBlocksUtils;
	const swiperEls = $$(
		'[class*="mzb-slider"] .swiper'
	) as unknown as Array<HTMLElement>;

	if (!swiperEls.length) return;

	import("swiper/modules").then(
		({ Navigation, Pagination, Autoplay, Keyboard }) => {
			import("swiper").then(({ Swiper }) => {
				each(toArray(swiperEls), (el) => {
					const config = JSON.parse(el.dataset?.swiper ?? "{}");

					new Swiper(el, {
						modules: [Navigation, Pagination, Autoplay, Keyboard],
						loop: true,
						slidesPerView:
							config.sliderStyle === "style3" ||
							config.sliderStyle === "style4"
								? parseInt(config.slidesPerView) || 1
								: 1,
						spaceBetween: 20,
						speed: config.speed ?? 500,
						autoplay: config.autoplay ? { delay: 5000 } : false,
						navigation: config.arrows
							? {
									nextEl: `.swiper-button-next`,
									prevEl: `.swiper-button-prev`,
							  }
							: false,
						pagination: config.pagination
							? {
									el: ".swiper-pagination",
									clickable: true,
							  }
							: false,
						grabCursor: false,
						simulateTouch: false,
						createElements: false,
						keyboard: {
							enabled: config.keyNavigation ?? false,
							onlyInViewport: true,
						},
						breakpoints: {
							320: {
								slidesPerView: Math.max(
									1,
									Math.floor(config.slidesPerView / 3)
								),
							},
							768: {
								slidesPerView: Math.max(
									2,
									Math.floor(config.slidesPerView / 2)
								),
							},
							1024: {
								slidesPerView: config.slidesPerView,
							},
						},
					});
				});
			});
		}
	);
});
